import React from 'react';
import BasicButton from '../../../../global/buttons/BasicButton';
import { IAddFormOptionButton } from '../../../interfaces/IFormBuilderButtons';



const AddFormOptionButton = ({ hideButton, text, ariaLabel, onButtonClick }: IAddFormOptionButton ) => {
    
    return (
        <BasicButton 
            className={`add-form-option-button ${hideButton ? 'hidden' : ''}`} 
            content={
                <>
                <span className='add-icon'>+</span>
                <span className='add-form-option-button-text'>{text || "Add Form Option"}</span>
                </>
            } 
            ariaLabel={ariaLabel} 
            onButtonClick={onButtonClick} 
        />
    );
};

export default AddFormOptionButton 